export default "__VITE_ASSET__DmS6yKCh__"